(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function drawer() { return document.querySelector('[data-cart-drawer]'); }

    function setOpen(open) {
      var d = drawer();
      if (!d) return;
      d.hidden = !open;
      d.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    function addDays(base, days) {
      var d = new Date(base);
      d.setDate(d.getDate() + days);
      return d;
    }

    /* Meme fourchette que la fiche produit et la page panier : elle vient de
       window.PM_LIVRAISON (snippets/livraison-estimee.liquid, reglages du
       theme > Livraison), en jours CALENDAIRES, rendu « 6 – 9 septembre ».
       Owner 02/09 midi : 4 a 7 jours partout. Le mode d'expedition du checkout
       (description « Livraison en 4 à 7 jours ») se change dans Shopify. */
    function fillDelivery() {
      var eta = drawer() && drawer().querySelector('[data-delivery-eta]');
      if (eta) {
        var dt = addDays(Date.now(), 7); /* 22/09 (owner) : 7 jours, même date que la fiche produit */
        eta.querySelector('[data-delivery-eta-date]').textContent =
          new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }).format(dt);
        eta.hidden = false;
      }
      var el = drawer() && drawer().querySelector('[data-delivery-estimate]');
      if (!el) return;
      var jour = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
      var mois = new Intl.DateTimeFormat('fr-FR', { month: 'long' });
      var PM = window.PM_LIVRAISON || { min: 4, max: 7 };
      var d1 = addDays(Date.now(), PM.min), d2 = addDays(Date.now(), PM.max);
      el.textContent = (mois.format(d1) === mois.format(d2) && d1.getFullYear() === d2.getFullYear())
        ? d1.getDate() + ' – ' + jour.format(d2)
        : jour.format(d1) + ' – ' + jour.format(d2);
    }

    function bind() {
      var d = drawer();
      if (!d) return;
      d.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });
      var checkout = d.querySelector('[data-drawer-checkout]');
      if (checkout) checkout.addEventListener('click', function () { window.location.href = '/checkout'; });

      d.querySelectorAll('[data-drawer-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('[data-line-key]');
          var qtyEl = line.querySelector('.drawer-qty__value');
          var next = Math.max(0, (parseInt(qtyEl.textContent, 10) || 0) + parseInt(btn.dataset.drawerQty, 10));
          /* 22/09 nuit (owner) : le chiffre restait a 1 pendant 1-2 s apres « + » (le temps de
             recharger tout le tiroir), la cliente croyait que ca n'avait pas marche. On montre le
             nouveau chiffre tout de suite, la ligne grisee et ses 2 boutons bloques jusqu'au rechargement. */
          qtyEl.textContent = next;
          line.classList.add('is-updating');
          line.querySelectorAll('[data-drawer-qty]').forEach(function (b) { b.disabled = true; });
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.dataset.lineKey, quantity: next })
          }).then(function () { refresh(true); }, function () { refresh(true); });
        });
      });

      var promo = d.querySelector('[data-drawer-promo]');
      if (promo) {
        promo.addEventListener('submit', function (e) {
          e.preventDefault();
          var code = promo.querySelector('input[name="discount"]').value.trim();
          var msg = d.querySelector('[data-promo-msg]');
          if (!code) return;
          fetch('/discount/' + encodeURIComponent(code))
            .then(function () {
              if (msg) {
                msg.hidden = false;
                msg.className = 'drawer-promo__msg drawer-promo__msg--ok';
                msg.textContent = msg.dataset.okText || ('Code « ' + code + ' » enregistré, appliqué au paiement.');
              }
            })
            .catch(function () {
              if (msg) {
                msg.hidden = false;
                msg.className = 'drawer-promo__msg drawer-promo__msg--err';
                msg.textContent = 'Impossible d’enregistrer le code, réessaie.';
              }
            });
        });
      }

      fillDelivery();
    }

    function refresh(openAfter) {
      // La fiche produit ne redirige PAS vers /cart quand un tiroir existe : si ce
      // rafraichissement echoue en silence, l'article est au panier mais l'ecran ne
      // bouge pas, et le client croit que son ajout n'a pas marche. On l'emmene donc
      // au panier plutot que de ne rien faire.
      function secours() { window.location.href = '/cart'; }
      /* 17/09 au soir : ON MEMORISE OU LE CLIENT EN EST DANS LA LISTE.
         Le tiroir est remplace EN ENTIER a chaque « − », « + » et a chaque
         « + Ajouter » de l'upsell, et le nouveau noeud repart a scrollTop 0.
         Tant que le paiement express etait dans le pied ancre, ca ne se voyait
         pas. Depuis qu'il est dans la zone qui defile, le scenario le plus
         courant — j'ajuste ma quantite puis je paie en 1 clic — renvoyait le
         client tout en haut et lui faisait refaire le scroll a chaque clic. */
      var ancien = drawer(), garde = ancien ? ancien.querySelector('.cart-drawer__scroll') : null;
      var position = garde ? garde.scrollTop : 0;
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) { if (openAfter) secours(); return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-cart-drawer]');
          var current = drawer();
          if (fresh && current) {
            current.replaceWith(fresh);
            bind();
            /* 06/09 : la fiche produit (bandeau 3+1) se resynchronise sur ce signal,
               y compris apres un − / + / suppression dans le tiroir (bug owner : le
               bandeau restait vert en repassant de 4 a 3). */
            document.dispatchEvent(new CustomEvent('cart:refreshed'));
            var count = document.querySelector('.cart-link__count');
            var freshCount = fresh.querySelector('[data-drawer-count]');
            if (count && freshCount) {
              var n = parseInt(freshCount.textContent, 10) || 0;
              count.textContent = n > 0 ? n : '';
              count.dataset.count = n;
            }
          }
          if (openAfter) setOpen(true);

          /* ⚠️ LA REPOSE DU DEFILEMENT DOIT VENIR ICI, APRES `setOpen`, ET PAS
             JUSTE APRES `replaceWith`. DEUX PIEGES MESURES LE 17/09 :
             1. la section rendue par le serveur arrive avec l'attribut `hidden`,
                donc `display: none` : ecrire `scrollTop` dessus ne fait RIEN.
                C'est `setOpen(true)` qui l'affiche, quinze lignes plus haut.
             2. meme visible, a cet instant les images des lignes et de l'upsell
                n'ont pas encore de hauteur : le contenu mesure a peine plus que
                la fenetre, le defilement maximum vaut ~0 et le navigateur
                ramene la valeur a 0.
             Releve avant correction : pose a 250, on relisait 0 apres un « + ».
             D'ou les quatre essais sur ~360 ms, arretes des que la cible est
             atteinte. Sans ca, chaque « − », « + » ou « + Ajouter » renvoie le
             client en haut de la liste et lui fait refaire tout le scroll pour
             retrouver le paiement en 1 clic, qui n'est plus dans le pied. */
          var zone = document.querySelector('.cart-drawer__scroll');
          if (zone && position > 0) {
            var vise = position, essais = 0;
            (function caler() {
              zone.scrollTop = vise;
              essais++;
              if (essais < 4 && zone.scrollTop < vise - 2) setTimeout(caler, 120);
            })();
          }
        })
        .catch(function () { if (openAfter) secours(); });
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.cart-link');
      if (!link || !drawer()) return;
      e.preventDefault();
      setOpen(true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    document.addEventListener('cart:updated', function () { refresh(true); });

    /* D1 (22/09, Clarity A1) : « Supprimer » sur /cart puis retour arrière = Safari
       réaffiche la fiche d'avant, tiroir et icône encore à 2 alors que le panier
       n'a plus qu'1 article (reproduit sur WebKit). Au retour arrière, on relit
       le panier, sans ouvrir le tiroir. */
    window.addEventListener('pageshow', function (e) {
      var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      if (!(e.persisted || (nav && nav.type === 'back_forward'))) return;
      /* Tiroir resté ouvert (client parti au paiement depuis le tiroir) : le fermer
         d'abord, sinon la page restait verrouillée sans défiler (relecture subagent). */
      var d = drawer();
      if (d && !d.hidden) setOpen(false);
      refresh(false);
    });

    /* « Complète ton pack » : délégué au document pour survivre au replaceWith() */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-upsell-variant]');
      if (!sel) return;
      var item = sel.closest('[data-upsell-item]');
      var opt = sel.options[sel.selectedIndex];
      var price = item && item.querySelector('[data-upsell-price]');
      if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-upsell-add]');
      if (!btn || btn.disabled) return;
      var item = btn.closest('[data-upsell-item]');
      var field = item && item.querySelector('[data-upsell-variant]');
      var id = field && parseInt(field.value, 10);
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Ajout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); return r.json(); })
        .then(function () {
          /* Page /cart : le bloc cadeau vit dans la page, pas dans le tiroir. On recharge pour que
             les lignes, la remise et le total suivent. */
          if (btn.closest('[data-upsell-reload]')) { window.location.reload(); return; }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
        });
    });

    bind();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coulisses"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-coulisses]').forEach(function (root) {
      var rail = root.querySelector('[data-coulisses-rail]');
      var dots = root.querySelectorAll('[data-coulisses-dots] .coulisses__dot');
      if (!rail || !dots.length || !('IntersectionObserver' in window)) return;
      // Un IntersectionObserver allume le DERNIER element entre, pas le plus visible :
      // au chargement les trois entrent d'un coup et c'est le 3e point qui s'allume.
      // La position de scroll, elle, ne ment pas.
      var items = Array.prototype.slice.call(rail.children);
      var maj = function () {
        var w = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap || 0);
        var i = Math.min(items.length - 1, Math.max(0, Math.round(rail.scrollLeft / w)));
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      };
      rail.addEventListener('scroll', function () {
        window.requestAnimationFrame(maj);
      }, { passive: true });
      maj();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /* Jauge de defilement, posee sur TOUS les rails de la page et pas seulement ceux
     de cette section : les blocs {% javascript %} du theme finissent dans un seul
     fichier, un unique passage suffit donc. On n'ajoute rien aux rails qui ne
     debordent pas, et on se remesure au redimensionnement — un rail complet en
     portrait peut deborder en paysage. */
  (function () {
    function pose(rail) {
      if (rail.dataset.jauge) return;
      var deborde = rail.scrollWidth - rail.clientWidth;
      if (deborde < 8) return;
      rail.dataset.jauge = '1';
      var jauge = document.createElement('div');
      jauge.className = 'rail-jauge';
      jauge.innerHTML = '<div class="rail-jauge__piste"><div class="rail-jauge__curseur"></div></div>';
      rail.insertAdjacentElement('afterend', jauge);
      var piste = jauge.firstChild, curseur = piste.firstChild;
      function maj() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (max < 8) { jauge.hidden = true; return; }
        jauge.hidden = false;
        var part = rail.clientWidth / rail.scrollWidth;
        var large = Math.max(piste.clientWidth * part, 24);
        curseur.style.width = large + 'px';
        curseur.style.transform =
          'translateX(' + (rail.scrollLeft / max) * (piste.clientWidth - large) + 'px)';
      }
      rail.addEventListener('scroll', maj, { passive: true });
      addEventListener('resize', maj);
      maj();
    }
    function toutes() { document.querySelectorAll('.rail').forEach(pose); }
    toutes();
    /* Les onglets rendent leurs panneaux caches : un rail cache mesure 0 et serait
       ignore. On repasse a chaque changement d'onglet. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-feat-tab]')) setTimeout(toutes, 30);
    });
    addEventListener('load', toutes);
  })();

  (function () {
    document.querySelectorAll('[data-feat]').forEach(function (root) {
      if (root.dataset.featPret) return; /* déjà branché (snippets/rayon-onglets.liquid) */
      root.dataset.featPret = '1';
      var tabs = root.querySelectorAll('[data-feat-tab]');
      if (!tabs.length) return;
      var titleEl = root.querySelector('[data-feat-title]');
      /* Le titre est reecrit a chaque changement d'onglet via textContent, ce qui
         effacerait le <span class="titre-trait">. On memorise donc les mots
         soulignes et on les repose apres coup. */
      var traitEl = titleEl && titleEl.querySelector('.titre-trait');
      var trait = traitEl ? traitEl.textContent : '';
      var subEl = root.querySelector('[data-feat-sub]');
      var lienEl = root.querySelector('[data-feat-link]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.featTab;
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          root.querySelectorAll('[data-feat-panel]').forEach(function (p) {
            p.hidden = p.dataset.featPanel !== i;
          });
          if (lienEl && tab.dataset.featTabUrl) lienEl.href = tab.dataset.featTabUrl;
          if (titleEl && tab.dataset.featTabTitle) {
            titleEl.textContent = tab.dataset.featTabTitle;
            if (trait) {
              titleEl.appendChild(document.createTextNode(' '));
              var sp = document.createElement('span');
              sp.className = 'titre-trait';
              sp.textContent = trait;
              titleEl.appendChild(sp);
            }
          }
          if (subEl) {
            var s = tab.dataset.featTabSub || '';
            subEl.textContent = s;
            subEl.hidden = s === '';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Apparition au defilement.

     La classe `js-anim` est posee sur <html> AVANT d'observer quoi que ce soit :
     c'est elle qui declenche le masquage en CSS. Sans JavaScript elle n'existe
     pas et rien n'est cache — une page blanche vaut toujours pire qu'une page
     sans animation.

     Les blocs deja visibles au chargement sont marques vus immediatement, sinon
     le haut de la page clignote a l'ouverture. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var cibles = '.section-head, .feat__grid, .feat__rail, .col-cards__grid,' +
                 '.spotlight-lb__head, .spotlight-lb__rail, .promo-bar__inner,' +
                 '.imgtext__inner, .vav, .quality-cards, .stats-counter';
    var doc = document.documentElement;
    doc.classList.add('js-anim');

    var vue = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-vu');
        vue.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    function armer() {
      document.querySelectorAll(cibles).forEach(function (el) {
        if (el.dataset.anim) return;
        el.dataset.anim = '1';
        if (el.getBoundingClientRect().top < innerHeight) {
          el.classList.add('is-vu');   /* deja a l'ecran : pas d'animation */
        } else {
          vue.observe(el);
        }
      });
    }
    armer();
    addEventListener('load', armer);
    /* Les panneaux d'onglets sont caches au chargement : leurs rails ne sont
       mesurables qu'apres le premier clic. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-feat-tab]')) setTimeout(armer, 30);
    });
  })();

  /* La barre est collee en haut et le header se colle SOUS elle. Sa hauteur depend
     du texte, qui peut passer sur deux lignes en petit ecran : on la mesure plutot
     que de la coder en dur, et on remesure au redimensionnement. */
  (function () {
    var barre = document.querySelector('.topbar');
    if (!barre) return;
    function mesure() {
      document.documentElement.style.setProperty('--h-topbar', barre.offsetHeight + 'px');
    }
    mesure();
    addEventListener('resize', mesure);
    addEventListener('load', mesure);
  })();

  (function () {
    var drawer = document.querySelector('[data-drawer]');
    var openBtn = document.querySelector('[data-drawer-open]');
    var searchToggle = document.querySelector('[data-search-toggle]');
    var searchBar = document.querySelector('[data-search-bar]');
    if (searchToggle && searchBar) {
      searchToggle.addEventListener('click', function () {
        var open = searchBar.hidden;
        searchBar.hidden = !open;
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var inp = searchBar.querySelector('[data-search-input]'); if (inp) inp.focus();
          /* ZipChat detourne le focus du champ et ouvre sa propre recherche, mais ne sait pas
             refermer une barre masquee par `hidden` : le client voyait deux recherches (13/09).
             Si sa recherche s'est ouverte, on replie la notre ; sans ZipChat, rien ne change. */
          setTimeout(function () {
            if (window.Zipchat && window.Zipchat._searchOverlayClose) {
              searchBar.hidden = true;
              searchToggle.setAttribute('aria-expanded', 'false');
            }
          }, 80);
        }
      });
    }

    function setDrawer(open) {
      if (!drawer) return;
      drawer.hidden = !open;
      drawer.classList.toggle('is-open', open);
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var topbar = document.querySelector('.topbar');
        var offset = 0;
        if (topbar) offset = Math.max(0, topbar.getBoundingClientRect().bottom);
        drawer.style.top = offset + 'px';
        drawer.querySelectorAll('.nav-panel').forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.panel === 'root');
        });
      }
    }

    if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
    if (drawer) {
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () { setDrawer(false); });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setDrawer(false);
    });

    var rotator = document.querySelector('[data-topbar-rotator]');
    if (rotator) {
      var msgs = rotator.querySelectorAll('.topbar__msg');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (msgs.length > 1 && !reduce) {
        var idx = 0;
        setInterval(function () {
          var out = msgs[idx];
          idx = (idx + 1) % msgs.length;
          var next = msgs[idx];
          // le sortant monte et s'efface pendant que l'entrant arrive par le bas :
          // les deux ne sont jamais lisibles au même endroit en même temps
          out.classList.remove('is-active');
          out.classList.add('is-leaving');
          next.classList.add('is-active');
          setTimeout(function () { out.classList.remove('is-leaving'); }, 400);
        }, 4200);
      }
    }

    if (drawer) {
      drawer.querySelectorAll('[data-open-panel]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.querySelectorAll('.nav-panel').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.panel === btn.dataset.openPanel);
          });
        });
      });
      drawer.querySelectorAll('[data-panel-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.querySelectorAll('.nav-panel').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.panel === 'root');
          });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* HERO en fondu (owner 07/09, référence maisontosport : Swiper effect "fade" + crossFade,
     autoplay 5 s, textes en fade-up, puce active qui se remplit). Ici sans librairie :
       - les diapos sont empilées (grid-area 1/1) ; la diapo active passe en opacité 1 (900 ms),
       - sur la diapo active : zoom lent de l'image (1 → 1,06) et remplissage de la puce,
         tous deux pilotés par UNE variable CSS --hero-p (0 → 1) mise à jour par requestAnimationFrame,
         donc parfaitement synchrones avec le compte à rebours, et en pause en même temps que lui,
       - textes de la diapo active en fade-up décalé (CSS),
       - glissé tactile / souris (40 px) = diapo précédente / suivante,
       - pause : survol, 8 s après un geste, onglet caché, hero hors écran, prefers-reduced-motion.
     Plus aucun scroll horizontal : plus de flou de rendu pendant le mouvement. */
  (function () {
    document.querySelectorAll('[data-hero-rail]').forEach(function (rail) {
      var slides = [].slice.call(rail.querySelectorAll(':scope > .hero__slide'));
      if (!slides.length) return;
      var hero = rail.closest('.hero');
      var dots = hero ? [].slice.call(hero.querySelectorAll('.hero__dot')) : [];
      var N = slides.length;
      var actif = 0;

      /* Diapos 2+ : images posées après le chargement (LCP), comme avant. */
      var deferred = rail.querySelectorAll('[data-hero-deferred]');
      /* 17/09 : hydratation diapo par diapo, et non plus toutes d'un coup.
         Avant, `hydrate()` posait les sources des quatre diapos 300 ms apres le
         `load`. Ca ne se voyait pas parce que le rail etait encore un flex-scroll :
         les diapos 2 a 4 etaient hors de l'ecran, et `loading="lazy"` les retenait.
         Depuis que le fondu est pose des le rendu (pour supprimer le saut de mise en
         page), elles sont EMPILEES sur la premiere, donc dans l'ecran, donc lazy ne
         retient plus rien : 996 Ko de photos partaient d'un coup.
         On ne pose donc plus que la diapo qu'on s'apprete a montrer, et celle
         d'apres pour que l'enchainement reste immediat. */
      function hydratePic(pic) {
        if (!pic) return;
        pic.querySelectorAll('source[data-srcset]').forEach(function (so) { so.srcset = so.dataset.srcset; so.removeAttribute('data-srcset'); });
        var im = pic.querySelector('img[data-src]');
        if (im) { im.srcset = im.dataset.srcset; im.src = im.dataset.src; im.removeAttribute('data-src'); im.removeAttribute('data-srcset'); }
        pic.removeAttribute('data-hero-deferred');
      }
      function hydrate(i) {
        if (!slides.length) return;
        var n = ((i % slides.length) + slides.length) % slides.length;
        hydratePic(slides[n].querySelector('[data-hero-deferred]'));
      }
      /* La deuxieme diapo seulement, et 1,5 s apres le `load` : a 300 ms elle partait
         en meme temps que l'image du LCP et lui prenait la bande passante (180 Ko).
         La premiere bascule du carrousel a lieu a 5 s, il reste donc tout le temps. */
      function preparerSuivante() { setTimeout(function () { hydrate(1); }, 1500); }
      if (document.readyState === 'complete') preparerSuivante();
      else window.addEventListener('load', preparerSuivante);

      var ecoule = 0, derniere = null, pauseJusqua = 0, survol = false, visible = true, rafId = null;
      var delai = parseInt(rail.getAttribute('data-autoplay') || '0', 10) * 1000;
      var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = delai > 0 && N > 1 && !reduit;

      function montrer(i) {
        actif = (i + N) % N;
        hydrate(actif);
        hydrate(actif + 1);
        slides.forEach(function (s, j) {
          var on = j === actif;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === actif); });
        ecoule = 0; derniere = null;
        (hero || rail).style.setProperty('--hero-p', '0');
      }
      function enPause() { return survol || !visible || document.hidden || Date.now() < pauseJusqua; }
      function tick(t) {
        rafId = requestAnimationFrame(tick);
        /* 23/09 (relecture) : add/remove à CHAQUE image réécrivait l'attribut class 60 fois par seconde et réveillait
           les observateurs de la page (bulle WhatsApp) même au repos : on ne touche la classe que si l'état change. */
        if (enPause()) { derniere = null; if (!rail.classList.contains('is-paused')) rail.classList.add('is-paused'); return; }
        if (rail.classList.contains('is-paused')) rail.classList.remove('is-paused');
        if (derniere !== null) ecoule += t - derniere;
        derniere = t;
        (hero || rail).style.setProperty('--hero-p', String(Math.min(1, ecoule / delai)));
        if (ecoule >= delai) montrer(actif + 1);
      }
      function geste() { pauseJusqua = Date.now() + 8000; }

      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === 0); s.setAttribute('aria-hidden', j === 0 ? 'false' : 'true'); });
      (hero || rail).style.setProperty('--hero-p', '0');
      rail.classList.add('hero__rail--fondu');

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { montrer(parseInt(dot.dataset.index, 10)); geste(); });
      });

      /* Glissé : tactile et souris. */
      var x0 = null, y0 = null;
      rail.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; geste(); }, { passive: true });
      rail.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) montrer(actif + (dx < 0 ? 1 : -1));
      }, { passive: true });
      rail.addEventListener('pointercancel', function () { x0 = null; }, { passive: true });
      rail.addEventListener('mouseenter', function () { survol = true; });
      rail.addEventListener('mouseleave', function () { survol = false; });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { montrer(actif + 1); geste(); }
        if (e.key === 'ArrowLeft') { montrer(actif - 1); geste(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.4 }).observe(rail);
      }
      /* Éditeur de thème : cliquer un bloc affiche sa diapo. */
      document.addEventListener('shopify:block:select', function (e) {
        var i = slides.indexOf(e.target); if (i > -1) { montrer(i); pauseJusqua = Date.now() + 60000; }
      });

      if (auto) { rail.classList.add('hero__rail--auto'); rafId = requestAnimationFrame(tick); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart-line__qty').forEach(function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var form = wrap.closest('form');
      function bump(delta) {
        var v = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = v;
        if (form) form.submit();
      }
      wrap.querySelector('[data-qty-minus]').addEventListener('click', function () { bump(-1); });
      wrap.querySelector('[data-qty-plus]').addEventListener('click', function () { bump(1); });
    });

    document.querySelectorAll('[data-remove-line]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var line = link.closest('.cart-line');
        var group = line && line.dataset.group;
        if (!group) return;
        e.preventDefault();
        var updates = {};
        updates[line.dataset.lineKey] = 0;
        line.querySelectorAll('.cart-line--addon').forEach(function (addon) {
          updates[addon.dataset.lineKey] = 0;
        });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-countdown], [data-countdown-daily]').forEach(function (el) {
      var daily = el.hasAttribute('data-countdown-daily');
      function endTime() {
        if (daily) {
          var mid = new Date();
          mid.setHours(24, 0, 0, 0);
          return mid.getTime();
        }
        return new Date(el.dataset.countdown).getTime();
      }
      var end = endTime();
      if (isNaN(end)) return;
      var d = el.querySelector('[data-cd-d]');
      var h = el.querySelector('[data-cd-h]');
      var m = el.querySelector('[data-cd-m]');
      var s = el.querySelector('[data-cd-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          if (daily) { end = endTime(); left = end - Date.now(); }
          else { el.hidden = true; clearInterval(timer); return; }
        }
        el.hidden = false;
        d.textContent = pad(Math.floor(left / 86400000));
        h.textContent = pad(Math.floor(left / 3600000) % 24);
        m.textContent = pad(Math.floor(left / 60000) % 60);
        s.textContent = pad(Math.floor(left / 1000) % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-produits"] && !Shopify.designMode) return;
  try {
    
  /* Rails : jauge (largeur = part visible, position = scrollLeft), fleches qui
     avancent d'une fenetre, onglets qui permutent les panneaux. Un seul passage
     pour toute la page ; les rails caches par un onglet sont remesures a
     l'ouverture (un rail cache mesure 0). */
  (function () {
    function armer(rail) {
      if (rail.dataset.arme) { mesurer(rail); return; }
      rail.dataset.arme = '1';
      var piste = rail.querySelector('[data-rprail-piste]');
      var curseur = rail.querySelector('[data-rprail-curseur]');
      var prev = rail.querySelector('[data-rprail-prev]');
      var next = rail.querySelector('[data-rprail-next]');
      function maj() {
        var max = piste.scrollWidth - piste.clientWidth;
        rail.classList.toggle('is-complet', max < 8);
        if (curseur) {
          var part = Math.min(1, piste.clientWidth / Math.max(1, piste.scrollWidth));
          curseur.style.width = (part * 100) + '%';
          var jauge = curseur.parentNode.clientWidth;
          curseur.style.transform = 'translateX(' + (max > 0 ? (piste.scrollLeft / max) * (jauge - jauge * part) : 0) + 'px)';
        }
        if (prev) prev.disabled = piste.scrollLeft < 4;
        if (next) next.disabled = piste.scrollLeft > max - 4;
      }
      rail._maj = maj;
      piste.addEventListener('scroll', function () { requestAnimationFrame(maj); }, { passive: true });
      addEventListener('resize', maj);
      if (prev) prev.addEventListener('click', function () { piste.scrollBy({ left: -piste.clientWidth * 0.9, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { piste.scrollBy({ left: piste.clientWidth * 0.9, behavior: 'smooth' }); });
      maj();
    }
    function mesurer(rail) { if (rail._maj) rail._maj(); }
    function tout() { document.querySelectorAll('[data-rprail]').forEach(function (r) { if (!r.hidden) armer(r); }); }
    tout();
    addEventListener('load', tout);

    document.querySelectorAll('[data-rprod]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-rprod-tab]');
      if (!tabs.length) return;
      var lien = root.querySelector('[data-rprod-lien]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.rprodTab;
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          root.querySelectorAll('[data-rprod-panel]').forEach(function (p) { p.hidden = p.dataset.rprodPanel !== i; });
          if (lien && tab.dataset.rprodUrl) lien.href = tab.dataset.rprodUrl;
          setTimeout(tout, 20);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-counter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-countup]');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function format(n) {
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function run(el) {
      var to = parseFloat(el.dataset.to) || 0;
      var pre = el.dataset.prefix || '';
      var suf = el.dataset.suffix || '';
      if (reduce) { el.textContent = pre + format(to) + suf; return; }
      var start = null;
      var dur = 1400;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + format(to * eased) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    els.forEach(function (el) {
      var raw = el.textContent.trim();
      var zero = raw.indexOf('0');
      el.dataset.prefix = zero > 0 ? raw.slice(0, zero) : '';
      el.dataset.suffix = zero > -1 ? raw.slice(zero + 1) : '';
      el.textContent = el.dataset.prefix + '0' + el.dataset.suffix;
    });

    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  (function () {
    var popup = document.querySelector('[data-welcome-popup]');
    if (!popup) return;
    var KEY = 'pm-welcome-popup';
    var jours = parseInt(popup.getAttribute('data-jours'), 10) || 30;
    var delai = parseInt(popup.getAttribute('data-delai'), 10) || 1200;
    var steps = popup.querySelectorAll('[data-welcome-step]');
    var form = popup.querySelector('#WelcomePopupForm');
    var tags = popup.querySelector('[data-welcome-tags]');
    var err = popup.querySelector('[data-welcome-err]');
    var go = popup.querySelector('[data-welcome-go]');
    var choix = '';

    function lire() {
      try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return { bloque: true }; }
    }
    function ecrire(etat) {
      try { localStorage.setItem(KEY, JSON.stringify(etat)); } catch (e) { /* stockage indispo */ }
    }
    function etape(n) {
      steps.forEach(function (s) { s.hidden = s.getAttribute('data-welcome-step') !== String(n); });
      var focus = popup.querySelector('[data-welcome-step="' + n + '"] input, [data-welcome-step="' + n + '"] .btn');
      if (focus) setTimeout(function () { focus.focus(); }, 50);
    }
    function ouvrir(n) {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      etape(n || 1);
    }
    function fermer() {
      popup.hidden = true;
      document.body.style.overflow = '';
      ecrire({ vu: Date.now(), fait: false });
    }

    // Retour de l'envoi : ?bienvenue=ok rouvre l'étape 3.
    var params = new URLSearchParams(window.location.search);
    if (params.get('bienvenue') === 'ok' || params.get('customer_posted') === 'true') {
      var etat0 = lire() || {};
      if (etat0.choix) {
        var btn0 = popup.querySelector('[data-welcome-choix="' + etat0.choix + '"]');
        if (btn0 && go) go.setAttribute('href', btn0.getAttribute('data-welcome-lien'));
      }
      ecrire({ vu: Date.now(), fait: true, choix: etat0.choix || '' });
      if (params.get('bienvenue') === 'ok' || (etat0.choix && !etat0.fait)) {
        ouvrir(3);
        history.replaceState(null, '', window.location.pathname);
      }
    } else {
      var etat = lire();
      var frais = etat && etat.vu && (Date.now() - etat.vu) < jours * 86400000;
      if (!(etat && (etat.bloque || etat.fait || frais))) {
        setTimeout(function () { if (popup.hidden) ouvrir(1); }, delai);
      }
    }

    popup.querySelectorAll('[data-welcome-close]').forEach(function (el) {
      el.addEventListener('click', fermer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) fermer();
    });

    popup.querySelectorAll('[data-welcome-choix]').forEach(function (el) {
      el.addEventListener('click', function () {
        choix = el.getAttribute('data-welcome-choix');
        if (tags) tags.value = 'newsletter, popup-bienvenue, ' + choix;
        if (go) go.setAttribute('href', el.getAttribute('data-welcome-lien'));
        ecrire({ vu: Date.now(), fait: false, choix: choix });
        etape(2);
      });
    });

    if (go) go.addEventListener('click', function () { ecrire({ vu: Date.now(), fait: true, choix: choix }); });

    if (form) {
      // Envoi NATIF (pas de fetch) : la boutique a la protection anti-spam Shopify
      // (hCaptcha), un POST en fetch repond 403. Le script captcha de Shopify
      // ecoute l'evenement submit du formulaire, pose le jeton et envoie ; Shopify
      // revient ensuite sur return_to = cette page + ?bienvenue=ok, qui rouvre
      // directement l'etape 3.
      var bouton = form.querySelector('[data-welcome-submit]');
      var retour = form.querySelector('input[name="return_to"]');
      form.addEventListener('submit', function () {
        if (retour) retour.value = window.location.pathname + '?bienvenue=ok';
        ecrire({ vu: Date.now(), fait: false, choix: choix });
        if (bouton) { bouton.disabled = true; bouton.textContent = '…'; }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
